import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import {
  Box, Typography, Button, Grid, Card, CardContent,
  Dialog, DialogContent, IconButton, useMediaQuery
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { alpha, useTheme } from '@mui/material/styles';
import { colors } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';

const About = () => {
  const [config, setConfig] = useState({ base_image_url: '' });
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'));

  useEffect(() => {
    fetch('/config.json')
      .then(res => res.json())
      .then(data => setConfig(data))
      .catch(err => console.error('Error fetching config:', err));
  }, []);

  const pdf1 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/alumini/alumni_2k16_17.pdf`;
  const pdf2 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/alumini/alumni_2k17_18.pdf`;
  const pdf3 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/alumini/alumni_2k18_19.pdf`;

  const excel2017 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/alumini/2017.xlsx`;
  const excel2018 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/alumini/2018.xlsx`;
  const excel2019 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/alumini/2019.xlsx`;

  const mock = [
    {
      title: 'Alumni 2016 - 17',
      description: 'Strong alumni network brings benefits to institutions.',
      illustration: '//pic.onlinewebfonts.com/svg/img_135736.png',
      color: colors.blue[200],
      pdf: pdf1,
      excel: excel2017,
    },
    {
      title: 'Alumni 2017 - 18',
      description: 'Congrats to Class 12 (2017-18) for achievements.',
      illustration: '//pic.onlinewebfonts.com/svg/img_135736.png',
      color: colors.green[200],
      pdf: pdf2,
      excel: excel2018,
    },
    {
      title: 'Alumni 2018 - 19',
      description: 'Congrats to Class 12 (2018-19) for their accomplishments.',
      illustration: '//pic.onlinewebfonts.com/svg/img_135736.png',
      color: colors.purple[200],
      pdf: pdf3,
      excel: excel2019,
    },
  ];

  // ✅ Handle Read More click
  const handleOpenDialog = (item) => {
    if (item.pdf && item.excel) {
      // ✅ Only open dialog if we have both PDF & Excel for the item
      setSelectedItem(item);
      setOpen(true);
    } else {
      // ✅ Otherwise open the href/pdf directly
      if (item.href) {
        window.open(item.href, '_blank');
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedItem(null);
  };

  return (
    <Box>
      <Grid container spacing={isMd ? 10 : 4}>
        {mock.map((item, i) => (
          <Grid key={i} item xs={12} md={4}>
            <Card sx={{ bgcolor: alpha(item.color, 0.2), height: '100%' }}>
              <CardContent sx={{ p: 4 }}>
                <Box display="flex" justifyContent="center" mb={2}>
                  <LazyLoadImage effect="blur" src={item.illustration} width="50%" />
                </Box>
                <Typography variant="h6" fontWeight={700} gutterBottom>
                  {item.title}
                </Typography>
                <Typography color="text.secondary" align="justify" noWrap>
                  {item.description}
                </Typography>

                 {/* ✅ Read More Button */}
                  <Button 
                    size={'large'}
                    onClick={() => handleOpenDialog(item)}
                    sx={{ marginTop: 2 }}
                  >
                    <Typography>Read more</Typography>
                  </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* ✅ Dialog Popup */}
            <Dialog open={open} onClose={handleClose}>
              <DialogTitle>{selectedItem?.title}</DialogTitle>
              <DialogContent>
                <Typography>
                  Choose a file to view:
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button 
                  variant="contained" 
                  color="primary" 
                  onClick={() => window.open(selectedItem?.pdf, '_blank')}
                >
                  View PDF
                </Button>
                <Button 
                  variant="contained" 
                  color="secondary" 
                  onClick={() => {
                     const excelUrl = encodeURIComponent(selectedItem?.excel);
                      window.open(`https://docs.google.com/viewer?url=${excelUrl}&embedded=true`, '_blank');
                  }}
                >
                  View Excel
                </Button>
                <Button color="error" onClick={handleClose}>Close</Button>
              </DialogActions>
            </Dialog>
    </Box>
  );
};

export default About;
